<template>
  <v-layout>
    <v-flex
      xs6
    >
      <input-money
        v-model="payload.initialValue"
        :input-key="`${inputKey}${$t('support.components.reports.initialValue')}First`"
        :rules="[valueLessThan(payload.finalValue)]"
        :label="$t('support.components.reports.initialValue')"
        :required="required"
      />
    </v-flex>
    <v-flex
      xs6
    >
      <input-money
        v-model="payload.finalValue"
        :input-key="`${inputKey}${$t('support.components.reports.finalValue')}Second`"
        :rules="[valueGreaterThan(payload.initialValue)]"
        :label="$t('support.components.reports.finalValue')"
        :required="required"
      />
    </v-flex>
  </v-layout>
</template>


<script>
import InputMoney from 'Support/components/inputs/InputMoney.vue';
import RulesMixin from 'Support/mixins/rules-mixin';

export default {
  name: 'MoneyInterval',
  components: {
    InputMoney,
  },
  mixins: [RulesMixin],
  props: {
    inputKey: {
      type: String,
      default: '',
    },
    value: {
      type: Object,
      required: true,
    },
    identifier: {
      type: String,
      required: true,
    },
    required: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    payload: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
    initialMoneyField() {
      return `initialMoneyField-${this.identifier}`;
    },
    finalMoneyField() {
      return `finalMoneyField-${this.identifier}`;
    },
  },
};
</script>
